import { render, staticRenderFns } from "./HouseholdWater.vue?vue&type=template&id=0b64581d&scoped=true&"
import script from "./HouseholdWater.vue?vue&type=script&lang=js&"
export * from "./HouseholdWater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64581d",
  null
  
)

export default component.exports